import { createReducer } from 'redux_new/handlers'
import types from './types'

const initialState = {
  token: '',
  tokenRefresh: ''
}

/**
 * Add auth token
 * @param {Object} action
 * @param {string} action.nxAuthToken
 */
const nxAuthTokenAdd = (state, action) => {
  const { nxAuthToken, tokenRefresh } = action

  return { token: nxAuthToken || '', tokenRefresh: tokenRefresh || '' }
}

export default createReducer(initialState, {
  [types.add]: nxAuthTokenAdd,
  [types.remove]: () => ({
    token: '',
    tokenRefresh: ''
  })
})
